import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Column as Column$2 } from './Column.styles.js';

var _excluded = ["children", "backgroundColor", "borderColor", "borderType", "image", "svg", "listIcon", "heading", "subheading", "hasSvg"];
var Column = function Column(_ref) {
  var children = _ref.children,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'none' : _ref$backgroundColor,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? 'none' : _ref$borderColor,
    _ref$borderType = _ref.borderType,
    borderType = _ref$borderType === void 0 ? 'none' : _ref$borderType,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$svg = _ref.svg,
    svg = _ref$svg === void 0 ? null : _ref$svg,
    _ref$listIcon = _ref.listIcon,
    listIcon = _ref$listIcon === void 0 ? null : _ref$listIcon,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? null : _ref$heading,
    _ref$subheading = _ref.subheading,
    subheading = _ref$subheading === void 0 ? null : _ref$subheading;
    _ref.hasSvg;
    var props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = props || {},
    aspectRatio = _ref2.aspectRatio,
    borderRadius = _ref2.borderRadius,
    customPosition = _ref2.customPosition;
  return /*#__PURE__*/React__default.createElement(Column$2, _extends({
    className: "leshen-column-wrapper",
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    borderType: borderType,
    svg: svg,
    listIcon: listIcon,
    aspectRatio: aspectRatio,
    borderRadius: borderRadius,
    customPosition: customPosition
  }, props), /*#__PURE__*/React__default.createElement("div", {
    className: "image-container"
  }, image), heading && heading, subheading && subheading, /*#__PURE__*/React__default.createElement("div", {
    className: "content"
  }, children));
};
var Column$1 = Column;

export { Column$1 as default };
//# sourceMappingURL=Column.js.map
